import {HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AlertService } from 'src/app/services/common/alert.service';


@Injectable()
export class ToastInterceptor implements HttpInterceptor {
  private lastShown = new Map<string, number>();
  private readonly windowMs = 1500; 

  constructor(private alertService: AlertService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          const body = event.body;
          const isMutating = req.method !== 'GET';

          const hdr = req.headers.get('X-Toast');
          const allowToast = hdr ? hdr === 'true' : isMutating;

          if (
            allowToast &&
            body?.message &&
            !req.url.includes('media')   
          ) {
            let message = body.message;

            if (req.url.includes('product') || req.url.includes('products')) {
              message = message.replace(/\bProduct\b/g, 'Item').replace(/\bproduct\b/g, 'item');
            }

            const key = `${req.method}|${req.urlWithParams}|${body.success}|${message}`;
            const now = Date.now();
            const last = this.lastShown.get(key) ?? 0;

            if (now - last > this.windowMs) {
              this.lastShown.set(key, now);
              body.success
                ? this.alertService.showSuccess(message)
                : this.alertService.showError(message);
            }
          }
        }
        return event;
      })
    );
  }
}

//previous
// import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
// import { Injectable } from "@angular/core";
// import { Observable } from "rxjs";
// import { map } from "rxjs/operators";
// import { AlertService } from "src/app/services/common/alert.service";

// @Injectable()
// export class ToastInterceptor implements HttpInterceptor {

//   constructor(
//     private alertService: AlertService
//   ) { }

//   intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
//     return next.handle(request).pipe(map((event: HttpEvent<any>) => {
//       if (event instanceof HttpResponse) {
//         if (event.body?.message && event.body?.success) {
//           this.alertService.showSuccess(event.body.message);
//         }
//         if (event.body?.message && !event.body?.success) {
//           this.alertService.showError(event.body.message);
//         }
//       }
//       return event;
//     }));
//   }
// }


